import { defineComponent } from 'vue';

export default defineComponent({
  name: 'spinner',
  props: {
    visible: {type: Boolean, default: false}
  }
});